import { Injectable } from '@angular/core';
import { FirebaseAnalytics } from '@capacitor-firebase/analytics';
import { ConsentType, ConsentStatus } from '@capacitor-firebase/analytics';
import { ENVIRONMENT } from '@viso/core/data-access';

@Injectable({
  providedIn: 'root'
})
export class FireAnalyticsService {

  constructor() { }

  async getAppInstanceId(): Promise<string | undefined> {
    const { appInstanceId } = await FirebaseAnalytics.getAppInstanceId();
    return appInstanceId;
  }

  async setConsent(type: ConsentType, status: ConsentStatus): Promise<void> {
    await FirebaseAnalytics.setConsent({ type, status });
  }

  async setUserId(userId: string): Promise<void> {
    await FirebaseAnalytics.setUserId({ userId });
  }

  async setUserProperty(key: string, value: string): Promise<void> {
    await FirebaseAnalytics.setUserProperty({ key, value });
  }

  async setCurrentScreen(screenName: string, screenClassOverride?: string): Promise<void> {
    await FirebaseAnalytics.setCurrentScreen({
      screenName,
      screenClassOverride
    });
  }

  async logEvent(name: string, params: { [key: string]: any }): Promise<void> {
    await FirebaseAnalytics.logEvent({ name, params });
  }

  async setSessionTimeoutDuration(duration: number): Promise<void> {
    await FirebaseAnalytics.setSessionTimeoutDuration({ duration });
  }

  async setEnabled(enabled: boolean): Promise<void> {
    await FirebaseAnalytics.setEnabled({ enabled });
  }

  async isEnabled(): Promise<boolean> {
    const { enabled } = await FirebaseAnalytics.isEnabled();
    return enabled;
  }

  async resetAnalyticsData(): Promise<void> {
    await FirebaseAnalytics.resetAnalyticsData();
  }

  async initiateOnDeviceConversionMeasurementWithEmailAddress(emailAddress: string): Promise<void> {
    await FirebaseAnalytics.initiateOnDeviceConversionMeasurementWithEmailAddress({ emailAddress });
  }

  async initiateOnDeviceConversionMeasurementWithPhoneNumber(phoneNumber: string): Promise<void> {
    await FirebaseAnalytics.initiateOnDeviceConversionMeasurementWithPhoneNumber({ phoneNumber });
  }

  async initiateOnDeviceConversionMeasurementWithHashedEmailAddress(emailAddressToHash: string): Promise<void> {
    await FirebaseAnalytics.initiateOnDeviceConversionMeasurementWithHashedEmailAddress({ emailAddressToHash });
  }

  async initiateOnDeviceConversionMeasurementWithHashedPhoneNumber(phoneNumberToHash: string): Promise<void> {
    await FirebaseAnalytics.initiateOnDeviceConversionMeasurementWithHashedPhoneNumber({ phoneNumberToHash });
  }
}